import { useNosIdQuery } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';

const applicationNamesQueryOptions = queryOptions({
  queryKey: ['application-names'],
  queryFn: () => api.get('/api/v1/applications/client-names'),
});

export function useGetApplicationsNames() {
  return useNosIdQuery(applicationNamesQueryOptions);
}
